export enum SubscriptionStatus {
  AWAITING_CONFIRMATION = 'Awaiting Confirmation',
  SUBSCRIPTION_TRIAL_ACTIVE = 'Trial Subscription',
  SUBSCRIPTION_TRIAL_EXPIRED = 'Trial Expired',
  FREE_SUBSCRIPTION_ACTIVE = 'Free Subscription Active',
  SUBSCRIPTION_ACTIVE = 'Subscription Active',
  SUBSCRIPTION_CANCELLED = 'Subscription Cancelled',
  SUBSCRIPTION_PAYMENT_ISSUES = 'Subscription Payment Issues'
}
